import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51d1d8d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row no-space col-12" }
const _hoisted_2 = { class: "td col-1" }
const _hoisted_3 = { class: "text-dark-grey" }
const _hoisted_4 = { class: "td col-3" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "td col-3" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "td col-1" }
const _hoisted_9 = { class: "td col-2" }
const _hoisted_10 = { class: "td col-2" }
const _hoisted_11 = ["disabled"]

import { computed, ref, toRefs } from 'vue'
import CreateWork from '@/components/AddWork/CreateWork.vue'
import { formatTrackDurationToString } from '@/helpers/tracks'
import { useGettext } from 'vue3-gettext'
import { createWorkEmitter } from '@/events/createWork'
import IconUI from '@/components/CommonUI/IconUI.vue'

interface TrackItemProps {
  track: Track,
  index: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TrackItem',
  props: {
    track: {},
    index: {}
  },
  setup(__props: any) {

const props = __props;

const { $gettext } = useGettext()


const isCreateWorkExpand = ref(false)
const { track } = toRefs(props)

const trackDurationString = formatTrackDurationToString(track.value.duration)
const trackTitle = computed(() => {
  if (track.value.trackMixVersion) {
    return `${track.value.title} (${track.value.trackMixVersion})`
  }

  return track.value.title
})

createWorkEmitter.on(`openTrack${track.value.id}`, () => {
  isCreateWorkExpand.value = true
})

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tr row", { opened: isCreateWorkExpand.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.index + 1), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("b", {
          class: "truncate-line",
          title: trackTitle.value
        }, _toDisplayString(trackTitle.value), 9, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: "text-primary truncate-line",
          title: _unref(track).artistsDisplayName
        }, _toDisplayString(_unref(track).artistsDisplayName), 9, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(trackDurationString)), 1),
      _createElementVNode("div", _hoisted_9, [
        _createTextVNode(_toDisplayString(_unref(track).isrc) + " ", 1),
        (_unref(track).isIsrcUsedWithPublishing)
          ? _withDirectives((_openBlock(), _createBlock(IconUI, {
              key: 0,
              class: "tooltip-icon",
              name: "tooltip",
              fill: "error",
              "data-testid": "isrc-already-in-use"
            }, null, 512)), [
              [_directive_tippy, { content: _unref($gettext)('You have already submitted a publishing registration that includes the ISRC linked to this track. Publishing claims are specific to the underlying musical composition. There is no need to submit additional registrations for releases that feature the same track / ISRC.') }]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "tertiary button-small",
          type: "button",
          disabled: _unref(track).isIsrcUsedWithPublishing,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isCreateWorkExpand.value = !isCreateWorkExpand.value))
        }, _toDisplayString(isCreateWorkExpand.value ? _unref($gettext)('Close') : _unref($gettext)('Register')), 9, _hoisted_11)
      ])
    ]),
    (isCreateWorkExpand.value)
      ? (_openBlock(), _createBlock(CreateWork, {
          key: 0,
          class: "col-12 create-work",
          track: props.track,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (isCreateWorkExpand.value = false))
        }, null, 8, ["track"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})